<template>
    <edn-field
      :irisMimic="irisMimic"
      ref="edn_phone"
      @update:error="isReady($event)"
      v-model="Value"
      @blur="isMimic"
      v-bind="$attrs"
      v-on="$listeners"
      v-if="!irisMimic"
      :pattern="pattern"
      :invalidMsg="invalidMsg"
    >
    </edn-field>
    <edn-mimic v-else :rules="rules" v-bind="$attrs" :pattern="pattern" v-model="Value" type="phone"  />
</template>

<script>
import { ednRequired } from './mixins/ednRequired'
import ednMimic from './ednMimic'
import { ednRegex } from './mixins/ednRegex'
import { ednValue } from './mixins/ednValue'

export default {
  mixins: [ednRequired,ednRegex, ednValue],
  inheritAttrs: false,
  components: {
    ednMimic,
  },
  props: {
    irisMimic: {
      type: Boolean,
      default: () => false,
    },
    // invalidMsg: {
    //   type: String,
    //   default: () => 'Vous devez entrer un numéro de téléphone valide.',
    // },
    pattern: {
      type: RegExp,
      /*eslint no-useless-escape: "error"*/
      default: () => /^$|^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im,
      /*eslint no-useless-escape: "error"*/
    },
    value: null,
  },
  data() {
    return {
      linkContent: '',
      readyToConvert: true,
      linkMode: false
    }
  },
  methods: {
    changeToLink() {
      this.linkContent = this.Value
    },
    isReady(e) {
      this.readyToConvert = !e
    },
    isMimic() {
      if (this.Value) this.linkMode = this.irisMimic && this.Value.length > 0 && this.readyToConvert
    },
    exit(e) {
      this.linkMode = e
    },
  },
  computed: {}
}
</script>
